var $ = require('jquery');

var $header = $('#header');
// Nav Toggle Button
$('#toggle').on('click', function () {
    $header.toggleClass('is-open');
});

$(window).on('scroll', function () {
    if ($(window).scrollTop() > 300) {
        $('.fixedlink').addClass('is-up');
        $('.cv').addClass('is-fixed');
        $('.pageTop').addClass('appear');
    } else {
        $('.fixedlink').removeClass('is-up');
        $('.cv').removeClass('is-fixed');
        $('.pageTop').removeClass('appear');
    }
});

$('.news__innerBtnsSelect select').on('change', function () {
    var val = $('.news__innerBtnsSelect select option:selected').val();
    if (val == '.news__innerBtnsSelect select') return;
    $('.news__innerContent').removeClass('active');
    $('div#' + val).addClass('active');
});

$('.page__containerBlockAccTtl').on('click', function () {
    $(this).next('.page__containerBlockAccContent').slideToggle();
    $(this).toggleClass("open");
});

$('.hyouka_research').on('click', function () {
    if (!$('#hyouka .page__containerBlockAccTtl').hasClass("open")) {
        $('#hyouka .page__containerBlockAccContent').slideToggle();
        $('#hyouka .page__containerBlockAccTtl').addClass("open");
    }

    var speed = 800; // ミリ秒
    // アンカーの値取得
    var href = $(this).attr("href");
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を数値で取得
    var position = target.offset().top - 100;
    // スムーススクロール
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
});

$('.hyouka_katei').on('click', function () {
    if (!$('#hyouka .page__containerBlockAccTtl').hasClass("open")) {
        $('#hyouka .page__containerBlockAccContent').slideToggle();
        $('#hyouka .page__containerBlockAccTtl').addClass("open");
    }

    var speed = 800; // ミリ秒
    // アンカーの値取得
    var href = $(this).attr("href");
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を数値で取得
    var position = target.offset().top - 100;
    // スムーススクロール
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
});

$('a[href^="#"]').on('click', function () {
    // スクロールの速度
    var speed = 800; // ミリ秒
    // アンカーの値取得
    var href = $(this).attr("href");
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を数値で取得
    var position = target.offset().top - 100;
    // スムーススクロール
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
});

var mediaQuery = matchMedia('(max-width: 1024px)');

// ページが読み込まれた時に実行
handle(mediaQuery);

// ウィンドウサイズが変更されても実行されるように
mediaQuery.addListener(handle);

function handle(mq) {
    if (mq.matches) {
        $('.header__innerNavListMenuLink').on('click', function () {
            $(this).next().slideToggle();
            $(this).toggleClass("open");
        });

        $('.footer__innerNavBlockListMenuLink').on('click', function () {
            $(this).next().slideToggle();
            $(this).toggleClass("open");
        });
    }
}
